import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve para cualquier nivel de ingresos?',
    a: 'Sí. Funciona tanto si ganás $200.000 como si ganás $2.000.000. El problema no es cuánto ganás sino qué hacés con lo que tenés. El Dominio Financiero te da el sistema para cualquier punto de partida.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente. Recibís un email con acceso a todos los PDFs en menos de 5 minutos, listos para descargar y leer en cualquier dispositivo.'
  }, {
    q: '¿Necesito saber de economía o finanzas?',
    a: 'No. Todo está escrito en lenguaje claro, directo y sin jerga. Si entendés cómo funciona tu tarjeta de crédito, podés entender estos tomos perfectamente.'
  }, {
    q: '¿Está adaptado a Argentina?',
    a: '100% adaptado al contexto argentino 2026. Cubrimos inflación, sistema bancario local, CEDEARs, Dólar MEP, monotributo y estrategias reales para nuestra economía.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total. Si no estás satisfecho, te hacemos la devolución total sin hacer preguntas.'
  }, {
    q: '¿Qué diferencia tiene con lo gratis en internet?',
    a: 'Lo gratis son consejos sueltos, contradictorios y pensados para economías estables. Esto es un sistema completo, secuencial y específico para Argentina, con plantillas listas para usar.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-surface py-16 px-4" data-id="element-89">
      <div className="max-w-3xl mx-auto" data-id="element-90">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 text-ink font-serif" data-id="element-91">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-92">
          {faqs.map((faq, i) => <div key={i} className="bg-white border border-border rounded-xl overflow-hidden shadow-sm" data-id="element-93">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-cream/50 transition-colors" data-id="element-94">
                <span className="font-bold text-ink text-base md:text-lg pr-4 font-serif" data-id="element-95">
                  {faq.q}
                </span>
                <ChevronDown className={`w-6 h-6 text-primary transition-transform duration-300 flex-shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-96" />
              </button>
              <AnimatePresence data-id="element-97">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-98">
                    <div className="px-6 pb-5 text-muted border-t border-border pt-4 text-sm md:text-base font-medium leading-relaxed" data-id="element-99">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}